
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 88.1 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#dfe1ff","d":"M9.66 1.75h75.91V51.8H9.66z"}}),_c('path',{attrs:{"d":"M9.91 33.01a2 2 0 00-1.42.65 2 2 0 001.57 3.35h7a2 2 0 001.43-.58 2 2 0 000-2.85 2 2 0 00-1.44-.57H9.91zm46.28-3.16l24.53 20.16H15.56l24.93-19.75 6.31 5.28a2 2 0 002.57 0zM5.91 25.01a2 2 0 00-1.42.65 2 2 0 001.6 3.35h11a2 2 0 001.4-.58 2 2 0 000-2.85 2 2 0 00-1.44-.57H6.09a.54.54 0 00-.18 0zM84.09 6.44v41.13L59.31 27.23zM15.41 4.01h65.37l-32.69 27.4zm-5.5-4a2 2 0 00-1.82 2v15h-6a.54.54 0 00-.18 0 2 2 0 00-1.42.65 2 2 0 001.6 3.35h15a2 2 0 001.4-.58 2 2 0 000-2.85 2 2 0 00-1.44-.57h-5V6.44L37.34 27.6l-25.25 20v-4.59a2 2 0 00-.6-1.44 2 2 0 00-2.85 0 2 2 0 00-.58 1.44v9a2 2 0 002 2h76a2 2 0 002-2v-50a2 2 0 00-2-2h-76a.54.54 0 00-.18 0z","fill":"#687ab8"}})])
          )
        }
      }
    